import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.scss']
})
export class LoadingOverlayComponent {
  @Input() isLoading = false;
  @Input() title = 'Cargando información...';
  @Input() message = 'Por favor espere mientras se obtienen los datos';
  @Input() spinnerDiameter = 60;
}

